// import React, { useState, Fragment, Component } from 'react'
// import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import moment from "moment"
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle, Tooltip,
    Alert,
    Button,
    Table,
    Spinner
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'

import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";
import { AvField, AvForm } from "availity-reactstrap-validation"

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';
import Tabledetailpresensi from './Components/TableDetailComponent'
import CustomSelect from "../../GlobalComponents/CustomSelect";

import SimulationComponent from './Components/SimulationComponent'
import SimulationHonorerComponent from './Components/SimulationHonorerComponent'
import SimulationPTSPComponent from "./Components/SimulationPTSPComponent";

const createYearOption = (startYear = 2000) => {
    var currentYear = new Date().getFullYear() + 10, years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
        var newObj = {};
        var year = startYear++;
        newObj["label"] = year;
        newObj["value"] = year;
        years.push(newObj);
    }
    return years;
}

const createMonthOptions = () => {
    var months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];

    return months.map(function (month, i) {
        var newObj = {};
        newObj["label"] = month;
        newObj["value"] = ++i;

        return newObj;
    });
}
const formatDateNoTime = (value) => {
    if (value != '-' && value != '' && value != null) {
        let date = new Date(value);
        const day = date.toLocaleString('id-ID', { day: '2-digit' });
        const month = date.toLocaleString('id-ID', { month: '2-digit' });
        const year = date.toLocaleString('id-ID', { year: 'numeric' });

        return day + '-' + month + '-' + year;
    } else {
        return '-';
    }
}
const SortByName = (a, b) => {
    var anewdate = (a.tanggalSk).split("-").reverse().join("-");
    var bnewdate = (b.tanggalSk).split("-").reverse().join("-");
    var aName = bnewdate;
    var bName = anewdate;
    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
}
class IndexView extends Component {

    detailBloc = new DetailBloc()

    userdata = JSON.parse(localStorage.getItem('userdata'));

    constructor(props) {
        super(props)
        this.state = {
            start_date: moment().startOf('month').format('YYYY-MM-DD'),
            end_date: moment().endOf('month').format('YYYY-MM-DD'),
            // start_date : '',
            // end_date : '',
            yearOptions: createYearOption(new Date().getFullYear() - 30),
            monthOptions: createMonthOptions(),
            year: new Date().getFullYear(),
            month: moment().format('M')
        }

        this.activeRef = React.createRef()
    }

    componentDidMount() {
        // const activeRef = useRef();
        this.detailBloc.fetchDetail({ uuid: this.props.uuid })
        this.detailBloc.BKNServiceIdentitas({ uuid: this.props.uuid })
        this.detailBloc.BKNServiceJabatan({ uuid: this.props.uuid })
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        this.setState({
                            detail: response
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })

        this.detailBloc.BKNServiceIdentitasChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        // console.log(response)
                        this.setState({
                            bknServiceIdentitas: response.data,
                            pnsId: response.data.id,
                            instansiId: response.data.instansiKerjaId,
                        })
                        //console.log('xxx')
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.BKNServiceJabatanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        var bkn = response.bkn;
                        var simpeg = response.simpeg;
                        if (bkn.code == 0) {
                            // console.log('bkn error')
                            this.setState({
                                bknServiceJabatan: [],
                            })
                        } else {
                            var bkn_sort = (response.bkn.data).sort(SortByName);
                            this.setState({
                                bknServiceJabatan: bkn_sort,
                            })
                        }
                        
                        if(simpeg.length > 0){
                            this.setState({
                                simpegServiceJabatan: response.simpeg
                            },function(){
                                // console.log('ghany ', this.state.simpegServiceJabatan)
                                // console.log('ghany ', this.state.bknServiceJabatan)
                            })
                        }else{
                            // console.log('simpeg error')

                        }

                        this.setState({ loadingTable: false })
                        console.log(response)
                        // var wew = (response.bkn.data).sort(SortByName);
                        // console.log(wew)


                        // this.setState({
                        //     bknServiceJabatan: wew,
                        //     simpegServiceJabatan: response.simpeg
                        // })
                        // this.setState({ loadingTable: false })

                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.sendToBKNChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        let code = response.code

                        if (code == 0) {
                            this.setState({
                                loading: false,
                                failed: true,
                                loadingTable: false
                            });
                        } else {
                            this.setState({
                                loading: false,
                                success: true,
                                loadingTable: false
                            });
                            this.handleIntegrasiJabatan()
                        }

                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.detailBloc.sendToSIMPEGChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            loading: false,
                            success: true,
                            loadingTable: false
                        });
                        this.handleIntegrasiJabatan()

                    } else {
                        this.setState({
                            loading: false,
                            failed: true,
                            loadingTable: false
                        });
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)

        this.detailBloc.exportChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        urlFileDetail: link,
                        loading: false,
                        failed: true
                    })
                    setTimeout(function () {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })

        this.detailBloc.downloadFileChannel.subscribe((result) => {

            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loading: true,
                    })
                    break
                case apiResponse.COMPLETED:
                    console.log('xxxx');
                    const link = result.data.response
                    window.open(link.file_url, "_blank")
                    //window.location.href = link.file_url
                    this.setState({
                        loading: false,
                        success: true
                    })
                    setTimeout(() => {
                        this.setState({
                            success: false,
                        })
                    }, 1000);
                    break
                case apiResponse.ERROR:
                    this.setState({
                        urlFileDetail: link,
                        loading: false,
                        failed: true
                    })
                    setTimeout(function () {
                        this.setState({
                            failed: false,
                        })
                    }, 1000)
                    break
                default:
                    break
            }
        })
    }

    reset = () => {
        this.setState({ start_date: '', end_date: '' })
    }

    reloadActiveRef = () => this.activeRef.current.setTokenAPI()

    handleIntegrasi = () => {
        this.setState({ loadingTable: true })
        this.detailBloc.BKNServiceIdentitas({ uuid: this.props.uuid })
    }
    handleIntegrasiJabatan = () => {
        this.setState({ loadingTable: true })
        this.detailBloc.BKNServiceJabatan({ uuid: this.props.uuid })
    }
    handleButtonSearch = () => {
        this.reloadActiveRef();
    }
    handleDownloadFile = (path) => {
        this.detailBloc.downloadFile({
            uuid: this.state.process_download_uuid,
            fileurl: path
        });
    }

    handleButtonExport = () => {
        this.setState({ loading: true })
        var filter = this.props.filter
        this.detailBloc.fetchExport({
            uuid: this.props.uuid,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            nip: this.state.detail.employee_nip,
            nama: this.state.detail.employee_full_name,
            jabatan: this.state.detail.employee_current_position_name,
            unit: this.state.detail.employee_current_work_unit_name
        });
    }
    sendToBKN() {
        this.detailBloc.sendToBKN({
            uuid: this.userdata?.employee_uuid,
            pnsId: this.state.pnsId,
            instansiId: this.state.instansiId,
            process_uuid: this.state.process_uuid,
        })
    }
    sendToSIMPEG() {
        this.detailBloc.sendToSIMPEG({
            uuid: this.userdata?.employee_uuid,
            employee_uuid: this.props.uuid,
            send_nama_jabatan: this.state.send_nama_jabatan,
            send_nomor_sk: this.state.send_nomor_sk,
            send_tgl_sk: this.state.send_tgl_sk,
            send_tmt_jabatan: this.state.send_tmt_jabatan,
            process_uuid: this.state.process_uuid,
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch (response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                if (this.state.runType == 5) {
                    this.sendToBKN()
                } else if (this.state.runType == 6) {
                    this.sendToSIMPEG()
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }


    render() {

        // const [nip, start_date] = useState('')
        // const [name, end_date] = useState('')

        // function handleButtonReset() {
        //     start_date('');
        //     end_date('');
        // }

        let filter = {
            // year: this.state.year,
            // month: this.state.month,
            start_date: this.state.start_date,
            end_date: this.state.end_date
        }

        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            {/* <PegawaiSideBar active="riwayatsumpah"/> */}

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Data Integrasi</CardTitle>
                                    <CardSubtitle className="mb-1">
                                        Informasi Detail Data Integrasi
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                    // onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                        : <Shimmer><div style={{ width: 68, height: 15 }}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_full_name !== "" ? this.state.detail.employee_full_name : '-'}</>
                                                        : <Shimmer><div style={{ width: '60%', height: 15 }}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Jabatan
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                        : <Shimmer><div style={{ width: '40%', height: 15 }}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Unit Kerja
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_current_work_unit_name !== "" ? this.state.detail.employee_current_work_unit_name : '-'}</>
                                                        : <Shimmer><div style={{ width: '40%', height: 15 }}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-1">
                                            <label className="col-md-3">
                                                Terakhir Sinkronisasi
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.last_update_integrasi !== "" ? this.state.detail.last_update_integrasi : '-'}</>
                                                        : <Shimmer><div style={{ width: '40%', height: 15 }}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>


                                        {/* <hr />
                                        <br />
                                        <CardTitle>Data Integrasi Identitas &nbsp; &nbsp; &nbsp; <Button onClick={() => {
                                            this.handleIntegrasi()
                                        }} color="primary">Sinkronisasi Data Identitas dari SIMPEG - BKN</Button>  <Button color="danger">Rollback ke Versi sebelumnya</Button></CardTitle>
                                        <br />
                                        <Col >
                                            <div className="table-responsive">
                                                <Table className="table table-striped table-bordered table-hover">
                                                    <thead className="table-primary">
                                                        <tr style={{ border: '1px solid #c8cce1' }}>
                                                            <th className="text-center align-middle" width="25%">Data Integrasi</th>
                                                            <th className="text-center align-middle table-success" width="35%">SIMPEG</th>
                                                            <th className="text-center align-middle table-warning" width="35%">BKN</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style={{ border: '1px solid #c8cce1', backgroundColor: 'white' }}>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>NIP</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.nipBaru !== "" ? this.state.bknServiceIdentitas.nipBaru : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Nama</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_name !== "" ? this.state.detail.employee_name : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.nama !== "" ? this.state.bknServiceIdentitas.nama : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Gelar Depan</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_front_title !== "" ? this.state.detail.employee_front_title : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.gelarDepan !== "" ? this.state.bknServiceIdentitas.gelarDepan : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Gelar Belakang</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_end_title !== "" ? this.state.detail.employee_end_title : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.gelarBelakang !== "" ? this.state.bknServiceIdentitas.gelarBelakang : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Tempat Lahir</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_place_of_birth_city_text !== "" ? this.state.detail.employee_place_of_birth_city_text : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.tempatLahir !== "" ? this.state.bknServiceIdentitas.tempatLahir : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Tanggal Lahir</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_date_of_birth !== "" ? this.state.detail.employee_date_of_birth : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.tglLahir !== "" ? this.state.bknServiceIdentitas.tglLahir : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Agama</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_religion_name !== "" ? this.state.detail.employee_religion_name : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.agama !== "" ? this.state.bknServiceIdentitas.agama : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>
                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Email External</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_email_external !== "" ? this.state.detail.employee_email_external : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.email !== "" ? this.state.bknServiceIdentitas.email : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Email Internal</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_email_internal !== "" ? this.state.detail.employee_email_internal : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.emailGov !== "" ? this.state.bknServiceIdentitas.emailGov : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>NIK</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_identity_number !== "" ? this.state.detail.employee_identity_number : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.nik !== "" ? this.state.bknServiceIdentitas.nik : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Alamat</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_identity_address !== "" ? this.state.detail.employee_identity_address : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.alamat !== "" ? this.state.bknServiceIdentitas.alamat : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>No HP</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_mobile_phone_number !== "" ? this.state.detail.employee_mobile_phone_number : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.noHp !== "" ? this.state.bknServiceIdentitas.noHp : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                <b>
                                                                    <span style={{ color: ((this.state.detail?this.state.detail.employee_phone_number:'') != (this.state.bknServiceIdentitas?this.state.bknServiceIdentitas.noTelp:''))?'red':''}}>No Telp</span>
                                                                </b>
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_phone_number !== "" ? this.state.detail.employee_phone_number : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.noTelp !== "" ? this.state.bknServiceIdentitas.noTelp : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Pendidikan Terakhir</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_last_education_name !== "" ? this.state.detail.employee_last_education_name : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.tkPendidikanTerakhir !== "" ? this.state.bknServiceIdentitas.tkPendidikanTerakhir + ' ' + this.state.bknServiceIdentitas.pendidikanTerakhirNama : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>TMT CPNS</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{'-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.tmtCpns !== "" ? this.state.bknServiceIdentitas.tmtCpns : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>TMT PNS</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{'-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.tmtPns !== "" ? this.state.bknServiceIdentitas.tmtPns : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                <b>
                                                                    <span style={{ color: ((this.state.detail?this.state.detail.employee_current_position_name:'') != (this.state.bknServiceIdentitas?this.state.bknServiceIdentitas.jabatanNama:''))?'red':''}}>Jabatan</span>
                                                                </b>
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_current_position_name !== "" ? this.state.detail.employee_current_position_name : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.jabatanNama !== "" ? this.state.bknServiceIdentitas.jabatanNama : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>

                                                        <tr style={{ border: '1px solid #c8cce1' }} >
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}><b>Gol/Pangkat</b></td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.detail ?
                                                                        <>{this.state.detail.employee_current_rank_name !== "" ? this.state.detail.employee_current_rank_name + ' ' + this.state.detail.employee_current_rank_group_room : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                            <td className="text-left align-middle" style={{ backgroundColor: 'white' }}>
                                                                {
                                                                    this.state.bknServiceIdentitas ?
                                                                        <>{this.state.bknServiceIdentitas.pangkatAkhir !== "" ? this.state.bknServiceIdentitas.pangkatAkhir + ' ' + this.state.bknServiceIdentitas.golRuangAkhir : '-'}</>
                                                                        : <Shimmer><div style={{ width: '100%', height: 15 }}></div></Shimmer>
                                                                }
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                        </Col> */}
                                        <hr />
                                        <br />
                                        <CardTitle>Data Jabatan &nbsp; &nbsp; &nbsp; <Button onClick={() => {
                                            this.handleIntegrasiJabatan()
                                        }} color="primary">Sinkronisasi Data Jabatan dari BKN</Button>
                                            {/* <Button color="danger">Rollback ke Versi sebelumnya</Button> */}
                                        </CardTitle>
                                        <br />
                                        <Row className="mb-1">
                                            <Col md="6">
                                                <div className="table-responsive">
                                                    <Table className="table table-striped table-bordered">
                                                        <thead className="table-primary">
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)' }}>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} colSpan={5} width="95%">SIMPEG</th>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} rowSpan={2} width="5%">Aksi</th>
                                                            </tr>
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)', backgroundColor: 'rgb(255, 250, 233)' }}>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Nama Jabatan</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Nomor SK</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Tanggal SK</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>TMT Jabatan</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>File SK</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.loadingTable == false ?
                                                                
                                                                    this.state.simpegServiceJabatan.length > 0 ?

                                                                        this.state.simpegServiceJabatan.map((data, index) => {
                                                                            const databknServiceJabatan = this.state.bknServiceJabatan;
                                                                            const found = databknServiceJabatan.some(el => el.nomorSk.trim().toLowerCase() === data.position_history_decree_number.trim().toLowerCase());

                                                                            return (
                                                                                <tr id={'tr_jabatan_simpeg_' + index} style={{ border: '1px solid rgb(200, 204, 225)' }}>
                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-left text-success' : 'text-left'}>{data.position_history_position_name}</td>
                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-left text-success' : 'text-left'}>{data.position_history_decree_number}</td>
                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-center text-success' : 'text-center'}>{formatDateNoTime(data.position_history_decree_date)}</td>
                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-center text-success' : 'text-center'}>{formatDateNoTime(data.position_history_tmt_position_date)}</td>
                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-center text-success' : 'text-center'}>{data?.document != null ? <a target={"_blank"} href={data?.document?.documents_path}>Download</a> : '-'}</td>

                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-center text-success' : 'text-center'}>
                                                                                        {
                                                                                            data.position_history_is_bkn == null ?
                                                                                                <span>
                                                                                                    <button
                                                                                                        className="btn btn-primary btn-sm"
                                                                                                        id={"proses_" + data.position_history_id}
                                                                                                        onClick={() => {
                                                                                                            this.setState({
                                                                                                                process_uuid: data.position_history_uuid,
                                                                                                                confirm: true,
                                                                                                                runType: 5,
                                                                                                                confirmInfo: "Apakah anda yakin akan Mengirimkan data ini ke BKN?"
                                                                                                            })
                                                                                                        }}
                                                                                                        style={{
                                                                                                            marginRight: '2px',
                                                                                                            padding: '2px 5px'
                                                                                                        }}>
                                                                                                        <i className="uil-check-square"></i>
                                                                                                    </button>
                                                                                                    <Tooltip
                                                                                                        style={{
                                                                                                            marginBottom: 2
                                                                                                        }}
                                                                                                        placement="top" isOpen={this.state["detail_simpeg_" + data.position_history_id]} target={"proses_" + data.position_history_id}
                                                                                                        toggle={() => {
                                                                                                            this.setState({
                                                                                                                ["detail_simpeg_" + data.position_history_id]: !this.state["detail_simpeg_" + data.position_history_id]
                                                                                                            })
                                                                                                        }}
                                                                                                    >Kirim Ke BKN</Tooltip>
                                                                                                </span>
                                                                                                :
                                                                                                ''
                                                                                            // <span>
                                                                                            //     <button
                                                                                            //         className="btn btn-danger btn-sm"
                                                                                            //         id={"rollback_" + data.position_history_id}
                                                                                            //         onClick={() => {
                                                                                            //             this.setState({
                                                                                            //                 process_uuid: data.position_history_uuid,
                                                                                            //                 confirm: true,
                                                                                            //                 runType: 5,
                                                                                            //                 confirmInfo: "Apakah anda yakin akan Menghapus data ini?"
                                                                                            //             })
                                                                                            //         }}
                                                                                            //         style={{
                                                                                            //             marginRight: '2px',
                                                                                            //             padding: '2px 5px'
                                                                                            //         }}>
                                                                                            //         <i className="uil uil-sign-out-alt"></i>
                                                                                            //     </button>
                                                                                            //     <Tooltip
                                                                                            //         style={{
                                                                                            //             marginBottom: 2
                                                                                            //         }}
                                                                                            //         placement="top" isOpen={this.state["rollback_simpeg_" + data.position_history_id]} target={"rollback_" + data.position_history_id}
                                                                                            //         toggle={() => {
                                                                                            //             this.setState({
                                                                                            //                 ["rollback_simpeg_" + data.position_history_id]: !this.state["rollback_simpeg_" + data.position_history_id]
                                                                                            //             })
                                                                                            //         }}
                                                                                            //     >Rollback</Tooltip>
                                                                                            // </span>
                                                                                        }

                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })

                                                                        :
                                                                        <tr style={{ border: '1px solid #c8cce1' }}>
                                                                            <td colSpan="5" className="text-center">Tidak Ada Data</td>
                                                                        </tr>
                                                                    :
                                                                    <tr style={{ border: '1px solid #c8cce1' }}>
                                                                        <td colSpan="5" className="text-center"><Spinner className="m-2" color="primary" /></td>
                                                                    </tr>

                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                            <Col md="6">
                                                <div className="table-responsive">
                                                    <Table className="table table-striped table-bordered">
                                                        <thead className="table-primary">
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)' }}>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} colSpan={5} width="95%">BKN</th>
                                                                <th className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }} rowSpan={2} width="5%">Aksi</th>
                                                            </tr>
                                                            <tr style={{ border: '1px solid rgb(200, 204, 225)', backgroundColor: 'rgb(255, 250, 233)' }}>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Nama Jabatan</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Nomor SK</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>Tanggal SK</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>TMT Jabatan</td>
                                                                <td className="text-center align-middle" style={{ backgroundColor: 'rgb(255, 250, 233)' }}>File SK</td>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.loadingTable == false ?
                                                                    this.state.bknServiceJabatan.length > 0 ?

                                                                        this.state.bknServiceJabatan.map((data, index) => {
                                                                            const datasimpegServiceJabatan = this.state.simpegServiceJabatan;
                                                                            const found = datasimpegServiceJabatan.some(el => el.position_history_decree_number.trim().toLowerCase() === data.nomorSk.trim().toLowerCase());

                                                                            var path = '';
                                                                            if (data.path != null) {
                                                                                if (data.path[872]) {
                                                                                    path = data.path[872].dok_uri;
                                                                                }
                                                                            }
                                                                            var nama_jabatan = data.namaJabatan;
                                                                            if (data.jenisJabatan == '4') {
                                                                                nama_jabatan = ((nama_jabatan != '' && nama_jabatan != null) ? nama_jabatan : data.jabatanFungsionalUmumNama);
                                                                            } else if (data.jenisJabatan == '2') {
                                                                                nama_jabatan = ((nama_jabatan != '' && nama_jabatan != null) ? nama_jabatan : data.jabatanFungsionalNama);
                                                                            }
                                                                            return (
                                                                                <tr id={'tr_jabatan_bkn_' + index} style={{ border: '1px solid rgb(200, 204, 225)' }}>

                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-left text-success' : 'text-left'}>{nama_jabatan}</td>
                                                                                    <td className={data.position_history_is_bkn == 1 || found ? 'text-left text-success' : 'text-left'}>{data.nomorSk}</td>
                                                                                    <td className={found ? 'text-center text-success' : 'text-center'}>{data.tanggalSk}</td>
                                                                                    <td className={found ? 'text-center text-success' : 'text-center'}>{data.tmtJabatan}</td>
                                                                                    <td className={found ? 'text-center text-success' : 'text-center'}>{path != '' ? <a href="javascript:void(0);" onClick={() => {
                                                                                        this.setState({
                                                                                            process_download_uuid: data.id,
                                                                                        });
                                                                                        this.handleDownloadFile(path);
                                                                                    }}>Download</a> : '-'}</td>

                                                                                    <td className={found ? 'text-center text-success' : 'text-center'}>
                                                                                        <button
                                                                                            className="btn btn-primary btn-sm"
                                                                                            id={"proses_" + data.id}
                                                                                            onClick={() => {
                                                                                                this.setState({
                                                                                                    process_uuid: data.id,
                                                                                                    send_nomor_sk: data.nomorSk,
                                                                                                    send_tgl_sk: data.tanggalSk,
                                                                                                    send_tmt_jabatan: data.tmtJabatan,
                                                                                                    send_nama_jabatan: nama_jabatan,
                                                                                                    confirm: true,
                                                                                                    runType: 6,
                                                                                                    confirmInfo: "Apakah anda yakin akan Mengirimkan data ini ke SIMPEG?"
                                                                                                })
                                                                                            }}
                                                                                            style={{
                                                                                                marginRight: '2px',
                                                                                                padding: '2px 5px'
                                                                                            }}>
                                                                                            <i className="uil-check-square"></i>
                                                                                        </button>
                                                                                        <Tooltip
                                                                                            style={{
                                                                                                marginBottom: 2
                                                                                            }}
                                                                                            placement="top" isOpen={this.state["detail_simpeg_" + data.id]} target={"proses_" + data.id}
                                                                                            toggle={() => {
                                                                                                this.setState({
                                                                                                    ["detail_simpeg_" + data.id]: !this.state["detail_simpeg_" + data.id]
                                                                                                })
                                                                                            }}
                                                                                        >Kirim Ke SIMPEG</Tooltip>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })

                                                                        :
                                                                        <tr style={{ border: '1px solid #c8cce1' }}>
                                                                            <td colSpan="5" className="text-center">Data BKN Tidak ditemukan</td>
                                                                        </tr>
                                                                    :
                                                                    <tr style={{ border: '1px solid #c8cce1' }}>
                                                                        <td colSpan="5" className="text-center"><Spinner className="m-2" color="primary" /></td>
                                                                    </tr>

                                                            }
                                                        </tbody>
                                                    </Table>
                                                    <ConfirmAlert
                                                        confirmTitle="Konfirmasi!"
                                                        confirmInfo={this.state.confirmInfo}

                                                        loadingTitle="Mengambil data"
                                                        loadingInfo="Tunggu beberapa saat"

                                                        successTitle="Berhasil!"
                                                        successInfo="Data berhasil diproses"

                                                        failedTitle="Gagal!"
                                                        failedInfo="Data gagal diproses"

                                                        showConfirm={this.state.confirm}
                                                        showLoading={this.state.loading}
                                                        showSuccess={this.state.success}
                                                        showFailed={this.state.failed}

                                                        response={this.confirmResponse}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>


                                        <Row className="mb-1">
                                            <Col md="3"> <Link to="/kepegawaian/integrasi_simpeg_bkn.html?" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link></Col>
                                            {/* <Col md="9"> */}

                                            {/* </Col> */}
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>

        )
    }
}

//export default IndexView
export default withRouter(IndexView);